import { FormLabel, Grid, TextField, Typography } from "@mui/material";
import { useProyecto } from "../../../data/ProyectoContext";
import { useActividadesContext } from "../../UmmIACategories/Hook/useActividades";

const ConsideracionesAdicionales = () => {
  const { setPromptData } = useActividadesContext();
  const { proyecto, setProyecto } = useProyecto();

  const handleCharacterizationProyectChange = (event) => {
    const { value } = event.target;
    setProyecto({ ...proyecto, consideraciones: value });
    setPromptData((prevData) => ({
      ...prevData,
      consideraciones: value,
    }));
  };

  return (
    <Grid xs={12} lg={12} md={12}>
      <Typography
        id="modal-modal-title"
        sx={{
          fontFamily: "montserrat",
          fontSize: "1.25rem",
          fontWeight: "bold",
          color: "#336B87",
        }}
      >
        Consideraciones adicionales{" "}
      </Typography>
      <FormLabel sx={{ fontFamily: "montserrat", fontSize: "0.85rem" }}>
        Comparte cualquier elemento especial o indicación que desees tener en
        cuenta al generar las preguntas de pensamiento crítico.
      </FormLabel>
      <TextField
        required
        id="contexto"
        placeholder="Escribe las consideraciones adicionales aquí."
        name="contexto"
        fullWidth
        autoComplete="given-name"
        variant="outlined"
        value={proyecto.consideraciones}
        onChange={handleCharacterizationProyectChange}
        InputProps={{
          sx: {
            borderRadius: 2,
            mt: 1,
            mb: 3,
            fontFamily: "montserrat",
            fontSize: "0.75rem",
            color: "#005559",
            "&::placeholder": {
              color: "#005559",
            },
            "&:before": {
              borderBottomColor: "#005559",
            },
            "&:after": {
              borderBottomColor: "#005559",
            },
          },
        }}
      />
    </Grid>
  );
};

export default ConsideracionesAdicionales;
